import { Pipe, PipeTransform } from '@angular/core';
import { ConfQuoteLine } from '../model';
import { MeasurementUnit } from '../common/enums';

@Pipe({
  name: 'productListLineTotalPieces',
  standalone: true,
  pure: false,
})
export class ProductListLineTotalPiecesPipe implements PipeTransform {
  transform(line: ConfQuoteLine): number {
    if (+line.unit == MeasurementUnit.Piece) {
      return line.qty;
    }

    const prod_to_smBox = line.product.product_products_to_small_box
      ? +line.product.product_products_to_small_box
      : 1;

    if (+line.unit == MeasurementUnit.SmallBox) {
      return line.qty * prod_to_smBox;
    }

    const smBox_to_Box = line.product.product_small_boxes_to_box
      ? +line.product.product_small_boxes_to_box
      : 1;

    if (+line.unit == MeasurementUnit.Box) {
      return line.qty * prod_to_smBox * smBox_to_Box;
    }

    const box_to_Palet = line.product.product_boxes_to_pallet
      ? +line.product.product_boxes_to_pallet
      : 1;

    if (+line.unit == MeasurementUnit.Palet) {
      return line.qty * prod_to_smBox * smBox_to_Box * box_to_Palet;
    }

    return 0;
  }
}
